import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import { PageHero, useTitle } from "../components/PageHero";
import { Reveal, Tag } from "../components/Reveal";
import { CTABand } from "../components/CTABand";
import { INSIGHTS } from "../data/insights";
import { IMG } from "../data/site";

export default function Insights() {
  useTitle("Insights — Industrial Knowledge Center | SABAKT Saudi Arabia");
  return (
    <main>
      <PageHero image={IMG.shopfloor} eyebrow="Knowledge Center" testid="insights-hero"
        title="Written for People Who Sign Purchase Orders." accent="Purchase Orders."
        text="Real purchasing and maintenance questions — wear plate selection, repair-vs-replace economics, RFQ preparation, Saudi industrial maintenance — answered by engineers." />
      <section className="py-20 lg:py-28">
        <div className="mx-auto grid max-w-7xl gap-px border border-seam bg-seam px-0 md:grid-cols-2 lg:grid-cols-3" style={{ margin: "0 auto", width: "calc(100% - 2rem)", maxWidth: "80rem" }}>
          {INSIGHTS.map((a, i) => (
            <Reveal key={a.slug} delay={(i % 3) * 0.07} className="h-full">
              <Link to={`/insights/${a.slug}`} data-testid={`insight-card-${a.slug}`}
                className="group flex h-full flex-col bg-obsidian p-8 transition-colors duration-300 hover:bg-steel">
                <div className="flex items-center justify-between">
                  <Tag>{a.category}</Tag>
                  <span className="font-mono text-[10px] text-cadmium/60">{a.minutes} min read</span>
                </div>
                <h2 className="mt-4 flex-1 font-display text-xl font-bold uppercase leading-snug tracking-wide text-frost group-hover:text-spark">
                  {a.title}
                </h2>
                <p className="mt-3 text-sm leading-relaxed text-cadmium">{a.excerpt}</p>
                <span className="mt-6 inline-flex items-center gap-2 font-mono text-[11px] uppercase tracking-widest text-spark">
                  Read Article <ArrowUpRight size={14} className="transition-transform duration-300 group-hover:translate-x-1" />
                </span>
              </Link>
            </Reveal>
          ))}
        </div>
      </section>
      <CTABand />
    </main>
  );
}
